export default {
  actions: 'Actions'
}